import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { Hero } from "./sections/Hero";
import { Company } from "./sections/Company";
import { Audiences } from "./sections/Audiences";
import { Product } from "./sections/Product";
import { Changeset } from "./sections/Changeset";
import { Capabilities } from "./sections/Capabilities";
import { Tasks } from "./sections/Tasks";
import { Simulation } from "./sections/Simulation";
import { Cad } from "./sections/Cad";
import { Pricing } from "./sections/Pricing";
import { Deployment } from "./sections/Deployment";
import { Cta } from "./sections/Cta";

export function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Hero />
        <Company />
        <Audiences />
        <Product />
        <Changeset />
        <Capabilities />
        <Tasks />
        <Simulation />
        <Cad />
        <Pricing />
        <Deployment />
        <Cta />
      </main>
      <Footer />
    </div>
  );
}
